import {Dto} from "common";

export abstract class ProtocolSummaryResultsModelDto extends Dto {
    abstract deserialize(input: any);
}

